import React from "react"
import VideoPlaylist from "../VideoPlaylist/videoPlaylist"

export const buildModalContent = (modalContent) => {
  return modalContent.map((item) => {
    if (item.rich_text_block) {
      return (
        <div
          className="modal_content_block modal_content_block--rich_text_block"
          dangerouslySetInnerHTML={{ __html: item.rich_text_block.rich_text_editor }}
        />
      )
    } else if (item.video_playlist) {
      return <VideoPlaylist data={item.video_playlist.entry[0]} />
    } else {
      return null;
    }
  })
}